import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Form, Button, Row, Col, Spinner, Alert, Image, InputGroup, Modal, Accordion, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import InputMask from 'react-input-mask';
import CurrencyInput from 'react-currency-input-field';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

// Estado inicial dos horários, similar ao de AgendasConfigTab.js
const initialHorariosState = {
    dom: { ativo: false, manha_inicio: '08:00', manha_fim: '12:00', tarde_inicio: '13:00', tarde_fim: '18:00', noite_inicio: '18:30', noite_fim: '20:00' },
    seg: { ativo: true, manha_inicio: '08:00', manha_fim: '12:00', tarde_inicio: '13:00', tarde_fim: '18:00', noite_inicio: '18:30', noite_fim: '20:00' },
    ter: { ativo: true, manha_inicio: '08:00', manha_fim: '12:00', tarde_inicio: '13:00', tarde_fim: '18:00', noite_inicio: '18:30', noite_fim: '20:00' },
    qua: { ativo: true, manha_inicio: '08:00', manha_fim: '12:00', tarde_inicio: '13:00', tarde_fim: '18:00', noite_inicio: '18:30', noite_fim: '20:00' },
    qui: { ativo: true, manha_inicio: '08:00', manha_fim: '12:00', tarde_inicio: '13:00', tarde_fim: '18:00', noite_inicio: '18:30', noite_fim: '20:00' },
    sex: { ativo: true, manha_inicio: '08:00', manha_fim: '12:00', tarde_inicio: '13:00', tarde_fim: '18:00', noite_inicio: '18:30', noite_fim: '20:00' },
    sab: { ativo: true, manha_inicio: '08:00', manha_fim: '12:00', tarde_inicio: '13:00', tarde_fim: '18:00', noite_inicio: '18:30', noite_fim: '20:00' },
};

const diasDaSemana = {
    seg: 'Segunda', ter: 'Terça', qua: 'Quarta', qui: 'Quinta', sex: 'Sexta', sab: 'Sábado', dom: 'Domingo'
};

const RegisterPage = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        entidade: {
            nome: '',
            cnpj: '',
            telefone: '',
            cep: '',
            numero: '',
            endereco: '',
            bairro: '',
            cidade: '',
            estado: '',
            complemento: '',
        },
        user: {
            nome: '',
            email: '',
            cpf: '',
            password: '',
            password_confirmation: '',
        },
        saldo: {
            valor_inicial: '',
            data_corte: new Date().toISOString().split('T')[0], // Padrão para hoje
        },
        // NOVAS SEÇÕES DE CONFIGURAÇÃO
        agenda: {
            duracao_padrao: 30,
            horarios: initialHorariosState,
        },
        layout: {
            logo: null, // Para armazenar o arquivo do logo
        },
        tags: {
            tags_interesse: '', // Novo campo para as tags
        }
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isCepLoading, setIsCepLoading] = useState(false);
    const [submitMessage, setSubmitMessage] = useState({ type: '', text: '' });
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [showTermsModal, setShowTermsModal] = useState(false);
    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [showPrivacyModal, setShowPrivacyModal] = useState(false);
    const [logoPreview, setLogoPreview] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const [section, field] = name.split('.');

        // Tratamento especial para o switch da agenda
        if (section === 'agenda' && field.startsWith('ativo-')) {
            const diaKey = field.split('-')[1];
            handleHorarioChange(diaKey, 'ativo', e.target.checked);
        } else {
            setFormData(prev => ({
                ...prev,
                [section]: {
                    ...prev[section],
                    [field]: value
                }
            }));
        }
    };

    // Handler específico para os horários da agenda
    const handleHorarioChange = (dia, campo, valor) => {
        setFormData(prev => ({
            ...prev,
            agenda: {
                ...prev.agenda,
                horarios: {
                    ...prev.agenda.horarios,
                    [dia]: { ...prev.agenda.horarios[dia], [campo]: valor }
                }
            }
        }));
    };

    // Handler para o upload do logo
    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        setFormData(prev => ({ ...prev, layout: { ...prev.layout, logo: file } }));
        setLogoPreview(file ? URL.createObjectURL(file) : null);
    };

    const handleCurrencyChange = (value, name) => {
        const [section, field] = name.split('.');
        setFormData(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: value || ''
            }
        }));
    };

    const handleCepBlur = async (e) => {
        const cep = e.target.value.replace(/\D/g, '');

        if (cep.length !== 8) {
            // Limpa a mensagem de erro se o CEP for inválido mas não necessariamente um erro de busca
            if (submitMessage.type === 'warning' && submitMessage.text.includes('CEP')) {
                setSubmitMessage({ type: '', text: '' });
            }
            return;
        }

        setIsCepLoading(true);
        setSubmitMessage({ type: '', text: '' }); // Limpa mensagens anteriores
        try {
            const { data } = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);

            if (data.erro) {
                setSubmitMessage({ type: 'warning', text: 'CEP não encontrado. Por favor, preencha o endereço manualmente.' });
                setFormData(prev => ({
                    ...prev, // Limpa os campos de endereço para preenchimento manual
                    entidade: { ...prev.entidade, endereco: '', bairro: '', cidade: '', estado: '', complemento: '' }
                }));
            } else {
                setFormData(prev => ({
                    ...prev,
                    entidade: {
                        ...prev.entidade,
                        endereco: data.logradouro,
                        bairro: data.bairro,
                        cidade: data.localidade,
                        estado: data.uf,
                    }
                }));
            }
        } catch (error) {
            console.error("Erro ao buscar CEP:", error);
            setSubmitMessage({ type: 'danger', text: 'Erro ao buscar o CEP. Tente novamente.' });
        } finally {
            setIsCepLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setSubmitMessage({ type: '', text: '' });

        const dataPayload = new FormData();

        // 1. Adiciona os dados da entidade (limpando máscaras)
        dataPayload.append('entidade[nome]', formData.entidade.nome);
        dataPayload.append('entidade[cnpj]', formData.entidade.cnpj.replace(/\D/g, ''));
        dataPayload.append('entidade[telefone]', formData.entidade.telefone.replace(/\D/g, ''));
        dataPayload.append('entidade[cep]', formData.entidade.cep.replace(/\D/g, ''));
        dataPayload.append('entidade[endereco]', formData.entidade.endereco);
        dataPayload.append('entidade[numero]', formData.entidade.numero);
        dataPayload.append('entidade[complemento]', formData.entidade.complemento || '');
        dataPayload.append('entidade[bairro]', formData.entidade.bairro);
        dataPayload.append('entidade[cidade]', formData.entidade.cidade);
        dataPayload.append('entidade[estado]', formData.entidade.estado);

        // 2. Adiciona os dados do usuário
        dataPayload.append('user[nome]', formData.user.nome);
        dataPayload.append('user[email]', formData.user.email);
        dataPayload.append('user[cpf]', formData.user.cpf.replace(/\D/g, ''));
        dataPayload.append('user[password]', formData.user.password);
        dataPayload.append('user[password_confirmation]', formData.user.password_confirmation);

        // 3. Adiciona os dados do saldo
        const valorInicial = parseFloat(String(formData.saldo.valor_inicial || '0').replace('.', '').replace(',', '.')) || 0;
        dataPayload.append('saldo[valor_inicial]', valorInicial);
        dataPayload.append('saldo[data_corte]', formData.saldo.data_corte);

        // 4. Adiciona os dados da agenda (como JSON string)
        dataPayload.append('agenda', JSON.stringify(formData.agenda));

        // 5. Adiciona o arquivo do logo, se existir
        if (formData.layout.logo) {
            dataPayload.append('logo', formData.layout.logo);
        }

        // 6. Adiciona as tags de interesse, se existirem
        if (formData.tags.tags_interesse) {
            dataPayload.append('tags_interesse', formData.tags.tags_interesse);
        }

        try {
            await axios.post('/api/onboarding/register-entity-user', dataPayload, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setSubmitMessage({ type: 'success', text: 'Cadastro realizado com sucesso! Você será redirecionado para a tela de login.' });
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (error) {
            const errors = error.response?.data;
            let errorMessage = 'Ocorreu um erro ao realizar o cadastro.';
            if (errors && typeof errors === 'object') {
                // Constrói uma mensagem de erro mais detalhada a partir dos erros de validação da API
                errorMessage = Object.values(errors).flat().join(' ');
            } else if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            }
            setSubmitMessage({ type: 'danger', text: errorMessage });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="register-page-background">
            <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', padding: '2rem 0' }}>
            <Card className="shadow-lg border-0" style={{ width: '100%', maxWidth: '800px', borderRadius: '15px' }}>
                <Card.Body className="p-4 p-md-5">
                    <div className="text-center">
                        <Image src="/logo.png" alt="Logo da Clínica" className="register-logo mb-3" />
                         <h4 className="fw-bold">Bem-vindo(a)!</h4>
                         {/* Seção de Vantagens */}
                         <Alert variant="success" className="my-4 text-start">
                            <div className="mt-5 text-center">
                                <h5 className="fw-bold">Uma plataforma completa para sua gestão, fácil prática e gratuita!</h5>
                                <p className="text-muted">Ao se registrar, você terá acesso a ferramentas poderosas:</p>
                                <Row className="mt-4 text-start">
                                    <Col md={6} className="mb-3">
                                        <div className="d-flex align-items-center">
                                            <span className="h3 me-3">📅</span>
                                            <div>
                                                <h6 className="fw-bold mb-0">Agenda Inteligente</h6>
                                                <p className="small text-muted mb-0">Gerencie consultas, horários e prontuários de forma integrada.</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <div className="d-flex align-items-center">
                                            <span className="h3 me-3">💰</span>
                                            <div>
                                                <h6 className="fw-bold mb-0">Financeiro Completo</h6>
                                                <p className="small text-muted mb-0">Controle faturamento, fluxo de caixa e gere relatórios DRE.</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <div className="d-flex align-items-center">
                                            <span className="h3 me-3">📦</span>
                                            <div>
                                                <h6 className="fw-bold mb-0">Estoque Organizado</h6>
                                                <p className="small text-muted mb-0">Monitore a entrada e saída de materiais, evitando desperdícios.</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <div className="d-flex align-items-center">
                                            <span className="h3 me-3">👥</span>
                                            <div>
                                                <h6 className="fw-bold mb-0">Gestão de Equipe</h6>
                                                <p className="small text-muted mb-0">Administre colaboradores, perfis de acesso e folha de pagamento.</p>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                         </Alert>
                        
                    </div>

                    <Alert variant="info" className="my-4 text-start">
                        
                        <Alert.Heading as="h6" className="fw-bold">Vamos configurar sua clínica em um único passo, ao preencher, nós iremos:</Alert.Heading>
                        <hr />
                        <ul className="list-unstyled mb-0 small">
                            <li className="mb-2">✓ <strong>Cadastro da Clínica:</strong> Criaremos o perfil principal do seu negócio.</li>
                            <li className="mb-2">✓ <strong>Seu Acesso de Administrador:</strong> Você será registrado como Representante Legal, com permissões totais.</li>
                            <li className="mb-0">✓ <strong>Ponto de Partida Financeiro:</strong> Configuraremos o saldo inicial para um controle preciso desde o primeiro dia.</li>
                        </ul>                        
                    </Alert>

                    <Form onSubmit={handleSubmit}>
                        {submitMessage.text && <Alert variant={submitMessage.type}>{submitMessage.text}</Alert>}

                        <Accordion defaultActiveKey="0" alwaysOpen>
                            <Accordion.Item eventKey="0"> 
                                <Accordion.Header>Passo 1: Dados da Clínica e Responsável (Obrigatório)</Accordion.Header>
                                <Accordion.Body>
                                    {/* Dados da Clínica */}
                                    <h5 className="mt-2 mb-3 form-section-title">Dados da Clínica</h5>
                                    <Row>
                                        <Col md={6}><Form.Group className="mb-3"><Form.Control placeholder="Nome da Clínica *" type="text" name="entidade.nome" value={formData.entidade.nome || ''} onChange={handleChange} required /></Form.Group></Col>
                                        <Col md={6}><Form.Group className="mb-3"><InputMask mask="99.999.999/9999-99" value={formData.entidade.cnpj || ''} onChange={handleChange}>{(inputProps) => <Form.Control {...inputProps} placeholder="CNPJ *" type="text" name="entidade.cnpj" required />}</InputMask></Form.Group></Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}><Form.Group className="mb-3"><InputGroup><InputMask mask="99999-999" value={formData.entidade.cep || ''} onChange={handleChange} onBlur={handleCepBlur}>{(inputProps) => <Form.Control {...inputProps} placeholder="CEP *" type="text" name="entidade.cep" required />}</InputMask>{isCepLoading && <Spinner animation="border" size="sm" className="ms-2" />}</InputGroup></Form.Group></Col>
                                        <Col md={6}><Form.Group className="mb-3"><InputMask mask="(99) 99999-9999" value={formData.entidade.telefone || ''} onChange={handleChange}>{(inputProps) => <Form.Control {...inputProps} placeholder="Telefone Principal *" type="text" name="entidade.telefone" required />}</InputMask></Form.Group></Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}><Form.Group className="mb-3"><Form.Control placeholder="Endereço *" type="text" name="entidade.endereco" value={formData.entidade.endereco || ''} onChange={handleChange} required /></Form.Group></Col>
                                        <Col md={2}><Form.Group className="mb-3"><Form.Control placeholder="Nº *" type="text" name="entidade.numero" value={formData.entidade.numero || ''} onChange={handleChange} required /></Form.Group></Col>
                                        <Col md={4}><Form.Group className="mb-3"><Form.Control placeholder="Complemento" type="text" name="entidade.complemento" value={formData.entidade.complemento || ''} onChange={handleChange} /></Form.Group></Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}><Form.Group className="mb-3"><Form.Control placeholder="Bairro *" type="text" name="entidade.bairro" value={formData.entidade.bairro || ''} onChange={handleChange} required /></Form.Group></Col>
                                        <Col md={4}><Form.Group className="mb-3"><Form.Control placeholder="Cidade *" type="text" name="entidade.cidade" value={formData.entidade.cidade || ''} onChange={handleChange} required /></Form.Group></Col>
                                        <Col md={4}><Form.Group className="mb-3"><Form.Control placeholder="Estado (UF) *" type="text" name="entidade.estado" value={formData.entidade.estado || ''} onChange={handleChange} required maxLength="2" /></Form.Group></Col>
                                    </Row>

                                    {/* Dados do Representante Legal */}
                                    <h5 className="mt-4 mb-3 form-section-title">
                                        Dados do Representante Legal
                                        <OverlayTrigger
                                            placement="right"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={<Tooltip id="tooltip-representante">Os dados informados aqui serão utilizados para o seu acesso principal à plataforma.</Tooltip>}
                                        >
                                            <span className="ms-2" style={{ cursor: 'pointer' }}>
                                                <FontAwesomeIcon icon={faInfoCircle} />
                                            </span>
                                        </OverlayTrigger>
                                    </h5>
                                    <Row>
                                        <Col md={6}><Form.Group className="mb-3"><Form.Control placeholder="Nome Completo *" type="text" name="user.nome" value={formData.user.nome || ''} onChange={handleChange} required /></Form.Group></Col>
                                        <Col md={6}><Form.Group className="mb-3"><InputMask mask="999.999.999-99" value={formData.user.cpf || ''} onChange={handleChange}>{(inputProps) => <Form.Control {...inputProps} placeholder="CPF *" type="text" name="user.cpf" required />}</InputMask></Form.Group></Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}><Form.Group className="mb-3"><Form.Control placeholder="Email de Acesso *" type="email" name="user.email" value={formData.user.email || ''} onChange={handleChange} required /></Form.Group></Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}><Form.Group className="mb-3"><Form.Control placeholder="Senha *" type="password" name="user.password" value={formData.user.password || ''} onChange={handleChange} required /></Form.Group></Col>
                                        <Col md={6}><Form.Group className="mb-3"><Form.Control placeholder="Confirme a Senha *" type="password" name="user.password_confirmation" value={formData.user.password_confirmation || ''} onChange={handleChange} required /></Form.Group></Col>
                                    </Row>

                                    {/* Horários de Atendimento */}
                                    <h5 className="mt-4 mb-3 form-section-title">Horários de Atendimento</h5>
                                    <Form.Group as={Row} controlId="duracaoPadrao" className="mb-3 align-items-center">
                                        <Form.Label column sm="auto" className="pe-2">Duração Padrão da Consulta (minutos):</Form.Label>
                                        <Col sm="auto" className="ps-0">
                                            <Form.Control type="number" name="agenda.duracao_padrao" value={formData.agenda.duracao_padrao} onChange={handleChange} min="15" max="60" style={{ width: '80px' }} />
                                        </Col>
                                    </Form.Group>
                                    {Object.entries(diasDaSemana).map(([diaKey, diaNome]) => (
                                        <Row key={diaKey} className="align-items-center mb-2 border-bottom pb-2">
                                            <Col md={2}><Form.Check type="switch" id={`switch-${diaKey}`} label={diaNome} checked={formData.agenda.horarios[diaKey].ativo} onChange={(e) => handleHorarioChange(diaKey, 'ativo', e.target.checked)} /></Col>
                                            <Col md={10}>
                                                <Row>
                                                    <Col><Form.Control type="time" size="sm" value={formData.agenda.horarios[diaKey].manha_inicio} onChange={(e) => handleHorarioChange(diaKey, 'manha_inicio', e.target.value)} disabled={!formData.agenda.horarios[diaKey].ativo} /></Col>
                                                    <Col><Form.Control type="time" size="sm" value={formData.agenda.horarios[diaKey].manha_fim} onChange={(e) => handleHorarioChange(diaKey, 'manha_fim', e.target.value)} disabled={!formData.agenda.horarios[diaKey].ativo} /></Col>
                                                    <Col><Form.Control type="time" size="sm" value={formData.agenda.horarios[diaKey].tarde_inicio} onChange={(e) => handleHorarioChange(diaKey, 'tarde_inicio', e.target.value)} disabled={!formData.agenda.horarios[diaKey].ativo} /></Col>
                                                    <Col><Form.Control type="time" size="sm" value={formData.agenda.horarios[diaKey].tarde_fim} onChange={(e) => handleHorarioChange(diaKey, 'tarde_fim', e.target.value)} disabled={!formData.agenda.horarios[diaKey].ativo} /></Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    ))}
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Passo 2: Configurações Adicionais (Opcional)</Accordion.Header>
                                <Accordion.Body>
                                    {/* Configuração Financeira */}
                                    <h5 className="mt-2 mb-3 form-section-title">Configuração Financeira Inicial</h5>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <CurrencyInput id="saldo.valor_inicial" name="saldo.valor_inicial" className="form-control" placeholder="Saldo Inicial em Caixa/Banco" value={formData.saldo.valor_inicial} decimalsLimit={2} decimalSeparator="," groupSeparator="." onValueChange={(value, name) => handleCurrencyChange(value, name)} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Control type="date" name="saldo.data_corte" value={formData.saldo.data_corte} onChange={handleChange} />
                                                <Form.Text muted>Data em que o saldo informado foi apurado.</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    {/* Logo da Entidade */}
                                    <h5 className="mt-4 mb-3 form-section-title">Logo da Clínica</h5>
                                    <Row>
                                        <Col md={4} className="text-center mb-3 mb-md-0">
                                            <h6>Preview</h6>
                                            <Image src={logoPreview || 'https://via.placeholder.com/150x100?text=Sem+Logo'} thumbnail style={{ maxHeight: '100px', width: 'auto' }} />
                                        </Col>
                                        <Col md={8}>
                                            <Form.Group controlId="formFile" className="mb-3">
                                                <Form.Label>Selecione um logo (PNG, JPG, GIF)</Form.Label>
                                                <Form.Control type="file" onChange={handleLogoChange} accept="image/png, image/jpeg, image/gif" help="Tamanho ideal: 300x150 pixels" />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    {/* Tags de Interesse */}
                                    <h5 className="mt-4 mb-3 form-section-title">Tags de Interesse para Pacientes</h5>
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Control type="text" name="tags.tags_interesse" value={formData.tags.tags_interesse} onChange={handleChange} placeholder="Ex: Botox, Preenchimento Labial, Harmonização Facial" />
                                                <Form.Text muted>Separe as diferentes tags por vírgula (,). Elas ajudarão a segmentar seus pacientes.</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>

                        <div className="mt-4">
                            <Form.Group className="mb-3" controlId="termsCheckbox">
                                <Form.Check type="checkbox" id="terms-checkbox" checked={termsAccepted} onChange={(e) => setTermsAccepted(e.target.checked)} label={<>Eu li e concordo com os <a href="#terms" onClick={(e) => { e.preventDefault(); setShowTermsModal(true); }}>Termos de Serviço</a>.</>} required />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="privacyCheckbox">
                                <Form.Check type="checkbox" id="privacy-checkbox" checked={privacyAccepted} onChange={(e) => setPrivacyAccepted(e.target.checked)} label={<>Eu li e concordo com a <a href="#privacy" onClick={(e) => { e.preventDefault(); setShowPrivacyModal(true); }}>Política de Privacidade</a>.</>} required />
                            </Form.Group>

                            <div className="d-grid mt-4">
                                <Button variant="success" type="submit" disabled={isLoading || !termsAccepted || !privacyAccepted} className="btn-success-gradient" size="lg">
                                    {isLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Criar Conta e Iniciar'}
                                </Button>
                            </div>
                        </div>
                    </Form>
                    
                </Card.Body>
            </Card>

            <Modal show={showTermsModal} onHide={() => setShowTermsModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Termos de Serviço</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    <p><strong>Última atualização:</strong> 01/08/2025</p>
                    <p>Bem-vindo à nossa plataforma! Ao se registrar e utilizar nossos serviços, você concorda com os seguintes termos e condições.</p>
                    <h5>1. Aceitação dos Termos</h5>
                    <p>Ao acessar ou usar a plataforma, você confirma que leu, entendeu e concorda em ficar vinculado a estes Termos de Serviço. Se você não concorda com estes termos, não deve usar a plataforma.</p>
                    <h5>2. Uso da Plataforma</h5>
                    <p>Você concorda em usar a plataforma apenas para fins legais e de acordo com todas as leis e regulamentos aplicáveis. Você é responsável por manter a confidencialidade de sua senha e conta.</p>
                    <h5>3. Coleta e Uso de Dados</h5>
                    <p>Nós coletamos informações pessoais e da sua clínica para fornecer e melhorar nossos serviços. Nossa Política de Privacidade, que é parte integrante destes Termos, descreve como coletamos, usamos e protegemos seus dados.</p>
                    <h5>4. Propriedade Intelectual</h5>
                    <p>Todo o conteúdo da plataforma, incluindo software, texto, gráficos e logotipos, é de nossa propriedade ou de nossos licenciadores e é protegido por leis de direitos autorais.</p>
                    <h5>5. Limitação de Responsabilidade</h5>
                    <p>A plataforma é fornecida "como está". Não garantimos que o serviço será ininterrupto ou livre de erros. Em nenhuma circunstância seremos responsáveis por quaisquer danos diretos ou indiretos resultantes do uso ou da incapacidade de usar a plataforma.</p>
                    <h5>6. Planos, Pagamentos e Limites de Uso</h5>
                    <p>O acesso à plataforma é concedido através de uma assinatura mensal paga. Cada plano de assinatura disponível define um limite específico de créditos que podem ser realizados dentro do ciclo de faturamento mensal. A entidade concorda em pagar as taxas associadas ao plano escolhido.</p>
                    <p>Caso o limite de créditos do plano seja atingido antes do final do ciclo, a entidade deverá adquirir pacotes de créditos adicionais para continuar utilizando esta funcionalidade. Os créditos não utilizados dentro do ciclo de faturamento não são acumulativos e expirarão ao final do período, não sendo transferidos para o ciclo subsequente.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowTermsModal(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showPrivacyModal} onHide={() => setShowPrivacyModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Política de Privacidade</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    <p><strong>Última atualização:</strong> 01/08/2025</p>
                    <p>A sua privacidade é importante para nós. É política do nosso sistema respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar.</p>
                    <h5>1. Informações que coletamos</h5>
                    <p>Coletamos informações pessoais que você nos fornece diretamente, como nome, e-mail, CPF, CNPJ e informações da clínica, quando você se registra e utiliza nossos serviços.</p>
                    <h5>2. Como usamos suas informações</h5>
                    <p>Usamos as informações que coletamos para operar, manter e fornecer os recursos e a funcionalidade da plataforma, para nos comunicarmos com você, para processar transações e para outros fins de atendimento ao cliente.</p>
                    <h5>3. Compartilhamento de informações</h5>
                    <p>Não compartilhamos suas informações pessoais com terceiros, exceto para cumprir a lei ou proteger nossos direitos.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowPrivacyModal(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            </Container>
        </div>
    );
};

export default RegisterPage;